<template>
  <div class='filter m-b-10' v-click-outside='closeDropdown'>
    <form class='default-filters'>
      <div v-for='filter in filterList' :key='filter' class='btn-group dropdown form-group' role='group' aria-expanded='false' ref='dropdown'>
        <button aria-expanded='false' aria-haspopup='true' data-toggle='dropdown'>
          {{ $t('root.filters.' + filter) }}
          <i class='fas fa-sort-down' aria-hidden='true'></i>
        </button>

        <div class='dropdown-menu'>
          <component :is="'filter-items-by-' + filter" @cancel='closeDropdown' />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import _filter_by_shared_with_contact from './_filter_by_shared_with_contact_name'
  import _filter_by_my_shared_folder_id from './_filter_by_my_shared_folder_id'
  import _filter_by_shared_contacts from './_filter_by_contact'
  import _filter_by_user_id from './_filter_by_user_id'
  import _filter_by_sharing_type from './_filter_by_sharing_type'
  import _filter_by_permission_type from './_filter_by_permission_type'
  import _filter_by_link_sharing_options from './_filter_by_link_sharing_options'

  export default {
    components: {
      'filter-items-by-contact_share': _filter_by_shared_with_contact,
      'filter-items-by-contact_connection': _filter_by_shared_contacts,
      'filter-items-by-my_shared_folders': _filter_by_my_shared_folder_id,
      'filter-items-by-users': _filter_by_user_id,
      'filter-items-by-sharing_type': _filter_by_sharing_type,
      'filter-items-by-permission_type': _filter_by_permission_type,
      'filter-items-by-link_sharing_options': _filter_by_link_sharing_options,
    },
    mounted() {
      $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
        if (!this.isClosable)
          return false

        this.isClosable = false
        return true
      })
    },
    data() {
      return {
        isClosable: false,
      }
    },
    computed: {
      filterList() {
        return Object.freeze(['contact_share', 'contact_connection', 'my_shared_folders', 'users', 'sharing_type', 'permission_type', 'link_sharing_options'])
      },
    },
    methods: {
      closeDropdown() {
        this.isClosable = true
      },
    },
  }
</script>

<style lang='sass' scoped>
  .filter
    display: flex
    margin-top: 10px
    .default-filters
      .dropdown
        > button
          background: none
          border: none
    .form-group
      margin-bottom: 0
      margin-right: 15px
    .dropdown-menu
      li
        color: #686868
        font-weight: 500
        padding-bottom: 5px
        a
          color: #686868
          font-weight: 500
      select
        border: 1px solid #ccc
        border-radius: 3px
        color: #686868
        font-weight: 500
        width: 100%
      label
        margin-bottom: 0
        padding: 5px 0 0
</style>
